import { useEffect, useState } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./activity-log.scss";
import { useDispatch, useSelector } from "react-redux";
import UserTable from "../user-table /user-table";
import { deleteUser, getUsers } from "features/authentication/userSlices";
import NewUserPopup from "../new-user-popup/new-user-popup";
import { boolean } from "yup";
import ConfirmationPopup from "../confirmation-popup/confirmation-popup";
import { getDetailedShops, getActivityLog, getShopsByUser } from "../../shopSlices";
import ActivityTable from "../activity-table/activity-table";


const ActivityLog = () => {
    const dispatch: Function = useDispatch();
    const user = useSelector((state: any) => state.auth.user);
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [userToEdit, setUserToEdit] = useState(null)
    const [wordToConfirm, setWordToConfirm] = useState(null)
    const [userIdToDelete, setUserIdToDelete] = useState(null)
    const activityLog = useSelector((state: any) => state.shop.activityLog);

    useEffect(()=>{
      if(user && user.sub){
        dispatch(getUsers(user.sub))
        dispatch(getShopsByUser(user.sub))
      }
      if(selectedShop)
        dispatch(getActivityLog(selectedShop))
    },[user?.sub, selectedShop])

  return (
    <div className="activity-log">
        <PageHierarchy />
        <div className="activity-log__preview-table">
          <ActivityTable/>
        </div>
    </div>
  );
};

export default ActivityLog;
